import { EmbeddedDocumentPostMessageResult } from "./index";

export class EmbeddedDocumentWindowInformationPostMessageResult extends EmbeddedDocumentPostMessageResult {
  constructor(
    windowName: string,
    request: string,
    isOk: boolean,
    public windowDetail?: EmbeddedWindowDetail,
  ) {
    super(windowName, request, isOk);
  }
}

export interface EmbeddedWindowDetail {
  minheight?: number;
  minwidth?: number;
}
